/**
 * @fileoverview EntryTimeRange — "09:00 to 09:30" for an entry that carries
 * a start time (MOR-935). Renders nothing for an entry posted to the day.
 */

import { entryEndTime } from "@cvx/timesheets/clock";
import { cn } from "@/utils/misc";

export function EntryTimeRange({
  entry,
  unitMinutes,
  className,
}: {
  entry: { startTime?: string; endTime?: string; units: number };
  unitMinutes: number;
  className?: string;
}) {
  const end = entryEndTime(entry, unitMinutes);
  if (!entry.startTime || !end) return null;
  return (
    <span
      className={cn("text-xs tabular-nums text-muted-foreground", className)}
    >
      {entry.startTime} to {end}
    </span>
  );
}
